import type { Site } from '../Site';

import { TechRadar } from './TechRadar';

export const TechRadarPro: Site = {
  ...TechRadar,
  id: 'techradarpro',
  logo: 'svg/techradar-pro.svg',
  label: 'TechRadar Pro',
  analyticsName: 'trdpro',
};
